// Necessary to override global stylees from index.scss
export const SuperScript = ({ children }: { children: string }) => (
  <sup style={{ top: '-0.5rem', left: '0' }}>{children}</sup>
);
